// extracted by mini-css-extract-plugin
export default {"cta":"iO-z","disabled":"jO-z"};